// src/components/Roles.jsx
import React, { useState, useEffect } from "react";
import clienteAxios from "../../axios";
import ModalConfirm from "../ModalConfirm";
import ModalAgregarRol from "./ModalAgregarRol"; // Modal para agregar nuevo rol

const Roles = () => {
    const [roles, setRoles] = useState([]);
    const [rolSeleccionado, setRolSeleccionado] = useState(null);
    const [editandoRol, setEditandoRol] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [showAgregarRolModal, setShowAgregarRolModal] = useState(false);
    const [rolAEliminar, setRolAEliminar] = useState(null);
    const [busqueda, setBusqueda] = useState("");

    // Obtener lista de roles
    const obtenerRoles = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Listar",
                modulo: "roles",
            });
            setRoles(response.data.data[0]);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        obtenerRoles();
    }, []);

    // Función para manejar la búsqueda
    const handleBusqueda = (e) => {
        setBusqueda(e.target.value.toLowerCase());
    };

    // Filtrar roles en función de la búsqueda
    const rolesFiltrados = roles.filter((rol) =>
        rol.nombre_rol?.toLowerCase().includes(busqueda) ||
        rol.descripcion?.toLowerCase().includes(busqueda)

    );

    // Función para editar un rol
    const editarRol = (rol) => {
        setEditandoRol(rol);
        setRolSeleccionado(rol.id);
    };

    // Guardar los cambios del rol editado
    const guardarRolEditado = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Actualizar",
                modulo: "roles",
                id: editandoRol.id,
                nombre_rol: editandoRol.nombre_rol,
                descripcion: editandoRol.descripcion,
            });
            setEditandoRol(null);
            setRolSeleccionado(null);
            obtenerRoles(); // Actualizar la lista de roles
        } catch (error) {
            console.log(error);
        }
    };

    // Confirmar eliminación de un rol
    const confirmarEliminarRol = (rol) => {
        setRolAEliminar(rol);
        setShowConfirmModal(true);
    };

    const eliminarRol = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Eliminiar",
                modulo: "roles",
                id: rolAEliminar.id,
            });
            setShowConfirmModal(false);
            obtenerRoles(); // Actualizar la lista de roles
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div className="mt-4 border p-4 rounded-lg">
            <h3 className="text-lg font-semibold">Roles</h3>

            {/* Barra de búsqueda */}
            <input
                type="text"
                placeholder="Buscar rol..."
                value={busqueda}
                onChange={handleBusqueda}
                className="border rounded-lg p-2 mb-4 w-1/2 min-w-[200px]"
            />

            {/* Botón para abrir el modal de agregar rol */}
            <button
                onClick={() => setShowAgregarRolModal(true)}
                className="bg-blue-500 text-white rounded px-4 py-2 mt-4 ml-6 hover:bg-blue-400"
            >
                Agregar Nuevo Rol
            </button>

            <ul className="mt-4">
                {rolesFiltrados.map((rol) => (
                    <li key={rol.id} className="border p-2 mb-2">
                        {editandoRol && editandoRol.id === rol.id ? (
                            <>
                                <div className="flex flex-col">
                                    <h3 className="font-semibold">Nombre del Rol:</h3>
                                    <input
                                        type="text"
                                        value={editandoRol.nombre_rol}
                                        onChange={(e) =>
                                            setEditandoRol({ ...editandoRol, nombre_rol: e.target.value })
                                        }
                                        className="border rounded-lg p-2 mb-2"
                                        maxLength={30}
                                    />

                                    <h3 className="font-semibold">Descripción:</h3>
                                    <input
                                        type="text"
                                        value={editandoRol.descripcion}
                                        onChange={(e) =>
                                            setEditandoRol({ ...editandoRol, descripcion: e.target.value })
                                        }
                                        className="border rounded-lg p-2 mb-2"
                                        maxLength={50}
                                    />

                                    <div className="flex mt-4">
                                        <button
                                            onClick={guardarRolEditado}
                                            className="bg-green-500 text-white rounded px-2 py-1 mr-2 w-40"
                                        >
                                            Guardar
                                        </button>
                                        <button
                                            onClick={() => setEditandoRol(null)}
                                            className="bg-gray-500 text-white rounded px-2 py-1 w-40"
                                        >
                                            Cancelar
                                        </button>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                            
                                <span><strong>Nombre:</strong> {rol.nombre_rol}</span><br />
                                <span><strong>ID Rol:</strong> {rol.id}</span><br />
                                <span><strong>Descripción:</strong> {rol.descripcion}</span><br />
                                <button
                                    onClick={() => editarRol(rol)}
                                    className="bg-gray-500 text-white rounded px-2 py-1 mt-2 hover:bg-gray-400"
                                >
                                    Editar
                                </button>
                                <button
                                    onClick={() => confirmarEliminarRol(rol)}
                                    className="bg-red-600 text-white rounded px-2 py-1 mt-2 ml-2 hover:bg-red-500"
                                >
                                    Eliminar
                                </button>
                            </>
                        )}
                    </li>
                ))}
            </ul>

            {/* Modal de confirmación para eliminar un rol */}
            <ModalConfirm
                show={showConfirmModal}
                message="¿Estás seguro de que quieres eliminar este rol?"
                onConfirm={eliminarRol}
                onCancel={() => setShowConfirmModal(false)}
            />

            {/* Modal para agregar un nuevo rol */}
            <ModalAgregarRol
                show={showAgregarRolModal}
                onClose={() => setShowAgregarRolModal(false)}
                onRolAgregado={obtenerRoles} // Actualizar la lista de roles tras agregar uno nuevo
            />
        </div>
    );
};

export default Roles;
